const sectores = [
  {
    id: "Agricultura, ganadería, alimentación, silvicultura y pesca",
    nombre: "Agricultura, ganadería, alimentación, silvicultura y pesca",
  },
  { id: "Arte y cultura", nombre: "Arte y cultura" },
  { id: "Comercio y reparaciones", nombre: "Comercio y reparaciones" },
  {
    id: "Construcción y actividades inmobiliarias",
    nombre: "Construcción y actividades inmobiliarias",
  },
  {
    id: "Entidades financieras y aseguradoras",
    nombre: "Entidades financieras y aseguradoras",
  },
  { id: "Hostelería", nombre: "Hostelería" },
  {
    id: "Industria extractiva, energía y agua",
    nombre: "Industria extractiva, energía y agua",
  },
  { id: "Industria y energía", nombre: "Industria y energía" },
  {
    id: "Información y telecomunicaciones",
    nombre: "Información y telecomunicaciones",
  },
  { id: "Servicios a las empresas", nombre: "Servicios a las empresas" },
  { id: "Servicios de ocio y turismo", nombre: "Servicios de ocio y turismo" },
  { id: "Servicios sociales", nombre: "Servicios sociales" },
  { id: "Servicios educativos", nombre: "Servicios educativos" },
  { id: "Transporte y almacenamiento", nombre: "Transporte y almacenamiento" },
  { id: "Otros", nombre: "Otros" },
];

const sectoresProfesionales = [
  { id: "Administración y gestión", nombre: "Administración y gestión" },
  { id: "Educación", nombre: "Educación" },
  { id: "Empleo", nombre: "Empleo" },
  { id: "Justicia", nombre: "Justicia" },
  { id: "Sanidad", nombre: "Sanidad" },
  { id: "Servicios sociales", nombre: "Servicios sociales" },
  { id: "Otros", nombre: "Otros" },
];

export { sectores, sectoresProfesionales };
